import { useGetListNotifications } from "@/modules/notifications/hooks/use-get-notifications";
import Image from "next/image";
import { useRouter } from "next/router";
import React from "react";

function Notification() {
  const router = useRouter();
  const { data: dataResult } = useGetListNotifications({
    is_read: false,
    limit: 100,
    page: 1,
    search: "",
    all: true,
  });
  const handleNotificationClick = () => {
    router.push("/notifications");
  };
  return (
    <div className="relative">
      <Image
        src="/admin/notifications.svg"
        alt=""
        width={16}
        height={20}
        onClick={handleNotificationClick}
        className="cursor-pointer"
      />
      {dataResult?.total > 0 && (
        <div className="absolute bg-[#ff5151] h-[10px] w-[10px] right-[2px] d-flex left-[58%] bottom-[44%] items-center p-1 rounded-full text-white"></div>
      )}
    </div>
  );
}

export default Notification;
